import { render, staticRenderFns } from "./modalRequirement.vue?vue&type=template&id=6b4fa944"
import script from "./modalRequirement.vue?vue&type=script&lang=js"
export * from "./modalRequirement.vue?vue&type=script&lang=js"
import style0 from "./modalRequirement.vue?vue&type=style&index=0&id=6b4fa944&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_s74suowdwcam3het7yodnr4dnu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports